var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isInitial)?_c('figure',{staticClass:"avatar",class:`avatar--${_vm.size} avatar--${_vm.shape}`,style:({ 'background-image': 'url('+_vm.backgroundImage+')' })}):_c('figure',{staticClass:"avatar avatar-initials",class:`avatar--${_vm.size} avatar--${_vm.shape} avatar--${_vm.initialColor}`},[_vm._v("\n  "+_vm._s(_vm.initial)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }